import React from "react";
import MapArea from "./MapArea";
import Measure from "react-measure";
import {browserHistory} from "react-router";

export default class Overview extends React.Component {
    constructor() {
        super();
        this.state = {
            map: null,
            width: -1,
            height: -1
        };

        this.updateDimensions = this.updateDimensions.bind(this);
        this.onAreaMouseEnter = this.onAreaMouseEnter.bind(this);
        this.onAreaMouseLeave = this.onAreaMouseLeave.bind(this);
    }

    componentDidMount() {
        if (!this.props.data['template_data']['overview']) {
            let firstMap = this.props.data['object_maps'][0];
            browserHistory.push(`/${this.props.params.widget}/map/${firstMap.id}`);
        }

        const map = this.props.data.overview_maps[0];

        this.setState({
            map: map,
        });
    }

    updateDimensions(dimensions) {
        if (!this.state) {
            return;
        }

        const ratio = this.state.map.width / this.state.map.height;

        this.setState({
            width: dimensions.width,
            height: dimensions.width / ratio
        });
    }

    onAreaClick(area) {
        browserHistory.push(`/${this.props.params.widget}/map/${area.map_id}`);
    }

    onAreaMouseLeave() {
    }

    onAreaMouseEnter() {
    }

    render() {
        if (!this.state.map) {
            return null;
        }

        const zoomLevel = this.state.width / this.state.map.width;

        const paths = this.state.map.regions.map((area) => {
//            const visible = area.object ? this.props.visibleRooms.indexOf(area.object.rooms) > -1 : false;
            const active = area.object ? this.props.hoverObject === area.object || this.props.showAll : false;

            return (
                <MapArea key={area.map_id} zoomLevel={zoomLevel} area={area}
                         active={active}
                         onMouseEnter={() => this.onAreaMouseEnter(area)}
                         onMouseLeave={() => this.onAreaMouseLeave(area)}
                         onClick={() => this.onAreaClick(area)}/>
            )
        });

        const style = {
            width: this.state.width + 'px',
            height: this.state.height + 'px',
        };

        return (
            <Measure onMeasure={this.updateDimensions}>
                <div>
                    <div className="cw-map-wrap cw-overview-map" style={style}>
                        <img src={`//webservices.carbonwhite.se${this.state.map.src}`} className="cw-map-image" alt="Map"/>
                        <svg style={style}>
                            {paths}
                        </svg>
                    </div>
                </div>
            </Measure>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Overview.jsx